import type { FaireProductEntity } from "../../entity_types/product";

export const p_ghawcn5n7n: FaireProductEntity = {
  token: "p_ghawcn5n7n",
  type: "product",
  name: "Mahjong 2-Row Ball Bead Stretch Bracelet in Shiny Gold",
  brandToken: "b_emgllltle6",
  brandName: "Canvas Style",
  imageUrl:
    "https://cdn.faire.com/fastly/22f0f171c54d30f9f2d625a1bfa3412995bfd6ad7bc9a72d081af79ad5a084a3.jpeg",
  galleryImageUrls: [],
  priceDollars: 12.5,
  description:
    "The Mahjong 2-Row Ball Bead Stretch Bracelet in Shiny Gold is a stunning piece that features two rows of shiny gold ball beads interspersed with Mahjong tile accents. This bracelet combines modern style with a touch of nostalgia, perfect for everyday wear.\n\n𝐃𝐄𝐓𝐀𝐈𝐋𝐒\n• Base Metal with Shiny Gold Plating",
  tags: [],
  msrpDollars: 42,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:44.087Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
